import { createApp } from '@app/adapters/create-app'
import AccountMapping from '@app/application/account-mapping/components/account-mapping'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='table-account-mapping']").each(function () {
    const dataset = this.dataset

    const accountMappingApp = createApp(AccountMapping, {
      ...dataset,
      messageBusLastId: parseInt(dataset.messageBusLastId),
      saveBatchSize: parseInt(dataset.saveBatchSize),
      mappingListAccountTypes: JSON.parse(dataset.mappingListAccountTypes),
      isAiMappingProposalSupported:
        typeof dataset.isAiMappingProposalSupported !== 'undefined',
      externalMappingsAvailable:
        typeof dataset.hasExternalMappingProposals !== 'undefined',
      supportedLocales: JSON.parse(dataset.supportedLocales),
    })

    accountMappingApp.mount(this)
  })

  const clickableRows = document.querySelectorAll(
    "[data-behaviour~='account']:not(.table-link-cells [data-behaviour~='account'])"
  )

  clickableRows.forEach((row) => {
    const link = $(row).data('account-link')

    if (link) {
      row.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        window.Turbolinks.visit(link)
      })
    }
  })
})
